import React, { useRef, useMemo } from 'react'
import {
  Container, Table, THead, TR, TH, TD, TBody, StyledRequired, Heading
} from './styles'
import Radio from '../Radio'

const TableOptions = ({
  name, headlines, options, onChange, value, required
}) => {
  const radioRefs = useMemo(() => options.map(() => React.createRef()), [])

  const onClick = (ref) => {
    ref.current.click()
  }

  return (
    <>
      <Container>
        <Heading>{headlines[0]}</Heading>
        {required ? (
          <StyledRequired>*</StyledRequired>
        ) : null}
        <Table>
          <THead>
            <TR>
              {headlines.map((headline) => (
                <TH key={headline}>{headline}</TH>
              ))}
            </TR>
          </THead>
          <TBody>
            {options.map((row, index) => {
              const { label, text, key } = row
              const textContent = text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
              return (
                <TR key={key} onClick={() => onClick(radioRefs[index])}>
                  <TD data-title={headlines[0]}>{label}</TD>
                  <TD data-title={headlines[1]} dangerouslySetInnerHTML={{ __html: textContent }} />
                  <TD data-title={headlines[2]}>
                    <Radio
                      name={name}
                      onChange={onChange}
                      defaultChecked={key === value}
                      value={key}
                      required={required}
                      ref={radioRefs[index]}
                    />
                  </TD>
                </TR>
              )
            })}
          </TBody>
        </Table>
      </Container>
    </>
  )
}
export default TableOptions
